import { fetchWithAuthCheck } from '@/services/fetchWithAuthCheck'
import type {
  DashboardInfoResponse,
  GetInfoResponse,
  ReadOnlyRequest,
} from '@/types/dashboard'

export async function getReadOnlyInfo(
  request: ReadOnlyRequest,
): Promise<DashboardInfoResponse> {
  const searchParams =
    'encryptedUrl' in request
      ? new URLSearchParams({ encryptedUrl: request.encryptedUrl })
      : new URLSearchParams({
          email: request.ownerEmail,
          workOrderId: String(request.workOrderId),
        })

  return fetchWithAuthCheck<GetInfoResponse>(
    `/dashboard/getReadOnlyInfo?${searchParams.toString()}`,
  )
}
